class DetailsModal extends HTMLElement {
  constructor() {
    super();

    const btnNavigationSearch = document.querySelector('.bot-navigation__search');
    
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );

    btnNavigationSearch.addEventListener(
      'click',
      this.onBtnNavigationClick.bind(this)
    );
    
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBtnNavigationClick(event) {
    event.preventDefault();
    const _this = this;
    
    if(this.detailsContainer.hasAttribute('open')) {
      this.close()
    } else {
      console.log(this.detailsContainer)
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      this.detailsContainer.setAttribute('open', true);
      console.log(this.detailsContainer)
      // document.body.addEventListener('click', function() {
      //   _this.close(true)
      // });
      this.querySelector('.modal-overlay').addEventListener('click', function() {
         _this.close(false)
      })
      
      document.body.classList.add('overflow-hidden');
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth' // 可选，平滑滚动
      });

      // trapFocus(
      //   this.detailsContainer.querySelector('[tabindex="-1"]'),
      //   this.detailsContainer.querySelector('input:not([type="hidden"])')
      // );
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
